/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlanReleasesEntryPointEntrypointProps } from './PlanReleasesEntryPoint.entrypoint.types.tsx';

type PlanReleasesEntryPointComponent = EntryPointComponent<
	{},
	{},
	PlanReleasesEntryPointEntrypointProps,
	{}
>;

export const planReleasesEntryPoint: EntryPoint<PlanReleasesEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<PlanReleasesEntryPointComponent>(
			/* webpackChunkName: "async-plan-releases-entrypoint" */ './PlanReleasesPlanReleases.tsx',
		),
		getPreloadProps: () => ({}),
	});
